/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_CLEARANCE,
  LOAD_CLEARANCE_SUCCESS,
  LOAD_CLEARANCE_ERROR,

  ADD_CLEARANCE,
  ADD_CLEARANCE_SUCCESS,
  ADD_CLEARANCE_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(clearanceMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    clearanceMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


//permission list
export function loadClearanceList(searchvalue) {
  return {
    type: LOAD_CLEARANCE,
    searchvalue,
  }
}
export function  loadClearanceListSuccess(clearance_details) {
  return {
    type:  LOAD_CLEARANCE_SUCCESS,
    clearance_details,
  }
}
export function loadClearanceListError(error) {
  return {
    type: LOAD_CLEARANCE_ERROR,
    error,
  }
}

//add clearance 

export function addClearance(applyClearance){
  return{
    type:ADD_CLEARANCE,
    applyClearance
  }
}
export function addClearanceSuccess(applyClearance, success) {
  return {
    type: ADD_CLEARANCE_SUCCESS,
    applyClearance,
    success
  }
}
export function addClearanceError(error) {
  return {
    TYPE:ADD_CLEARANCE_ERROR,
    error,
  }
}



const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadClearanceList,
  loadClearanceListSuccess,
  loadClearanceListError,

  addClearance,
  addClearanceError,
  addClearanceSuccess
}

export default actions
